import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    cardNumber: {
      label: {
        id: 'properties.card_number',
        defaultMessage: 'Card number',
        description: 'label of the form field card number',
      },
    },
    expirationDate: {
      label: {
        id: 'properties.expiration_date',
        defaultMessage: 'Expiration date',
        description: 'label of the form field expiration date',
      },
    },
    cvc: {
      label: {
        id: 'properties.cvc',
        defaultMessage: 'CVC',
        description: 'label of the form field CVC',
      },
    },
    bank: {
      label: {
        id: 'properties.bank',
        defaultMessage: 'Bank',
        description: 'label of the form field Bank',
      },
    },
    amount: {
      label: {
        id: 'properties.amount',
        defaultMessage: 'Amount',
        description: 'label of the form field price',
      },
    },
  },
  options: {
    creditCard: {
      title: {
        id: 'pages.contract.paymentMethods.options.creditCard.title',
        defaultMessage: 'Credit card',
        description: 'label of the credit card option',
      },
      description: {
        id: 'pages.contract.paymentMethods.options.creditCard.description',
        defaultMessage: 'Visa, American Express, MasterCard',
        description: 'description of the credit card option',
      },
    },
    iDeal: {
      title: {
        id: 'pages.contract.paymentMethods.options.iDeal.title',
        defaultMessage: 'Direct debit',
        description: 'label of the iDeal option',
      },
      description: {
        id: 'pages.contract.paymentMethods.options.iDeal.description',
        defaultMessage: 'Confirm with iDeal',
        description: 'description of the iDeal option',
      },
      steps: {
        info: {
          title: {
            id: 'pages.contract.paymentMethods.options.iDeal.steps.info.title',
            defaultMessage: 'Direct Debit',
            description: 'title of the info step of the ideal direct debit option',
          },
          description: {
            id: 'pages.contract.paymentMethods.options.iDeal.steps.info.description',
            defaultMessage:
              'To be able to use this method, we want to make sure you are the owner the account number that you want to use. To validate this, we ask you to transfer € 0.01 via iDEAL once.',
            description: 'description of the info step of the ideal direct debit option',
          },
          buttons: {
            continue: {
              id: 'actions.continue',
              defaultMessage: 'Continue',
              description: 'label of the continue button',
            },
            back: {
              id: 'actions.back',
              defaultMessage: 'Back',
              description: 'label of the back button',
            },
          },
        },
        bankSelect: {
          title: {
            id: 'pages.contract.paymentMethods.options.iDeal.steps.bankSelect.title',
            defaultMessage: 'Confirm bank account (iDEAL)',
            description: 'title of the bank select section',
          },
        },
      },
    },
  },
  formActions: {
    cancel: {
      id: 'formActions.cancel',
      defaultMessage: 'Cancel',
      description: 'label of the form action cancel button',
    },
    continue: {
      id: 'actions.continue',
      defaultMessage: 'Continue',
      description: 'label of the form action continue button',
    },
    confirm: {
      id: 'actions.confirm',
      defaultMessage: 'Confirm',
      description: 'label of the form action confirm button',
    },
    back: {
      id: 'actions.back',
      defaultMessage: 'Back',
      description: 'label of the form action back button',
    },
    save: {
      id: 'formActions.save',
      defaultMessage: 'Save',
      description: 'label of the form action save button',
    },
  },
};

export default defineMessages(translations);
